<template>
  <page-listado>
    <page-header title="Precios Hora" />
    <formulario-precios-hora :precios-hora="preciosHora" @submit="actualizar" />
  </page-listado>
</template>

<script>
import api from "@/services/preciosHora.js";
import FormularioPreciosHora from "./FormularioPreciosHora.vue";

export default {
  components: { FormularioPreciosHora },
  data() {
    return {
      preciosHora: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return api.listar(this.$route.query).then((resultado) => {
        this.preciosHora = resultado.preciosHora;
      });
    },
    actualizar() {
      api.actualizar(this.preciosHora).then(() => {
        this.$messages.success("Precios Hora actualizados");
      });
    },
  },
};
</script>
